export default "__VITE_ASSET__DE$nhI45__"